module.exports = __webpack_public_path__ + "img/pumpjack-base-shadow.d3a47dfc.png";